import { TemplatePage } from './types';

const live_streaming_starting_soon: TemplatePage = {
  header: {
    color: '#FFE095',
    icon: 'images/video-templates/starting.jpg',
    title: 'Starting Soon Screen Templates',
    title_meta: '20+ Free Starting Soon Screen Templates',
    description_meta:
      'Design stylish Starting Soon screen for your live stream with Wave.video’s free and easily' +
      ' customizable templates. Boost the excitement before the show!',
    description:
      'Tease the viewers of your live stream before it starts! Make a unique and stylish Starting Soon' +
      ' screen to signal early attendees about the beginning of your show.'
  },
  footer: {
    category: 'Live streaming starting soon screen',
    description:
      'With Wave.video’s collection of editable templates, you can be on top of the live streaming game' +
      ' even with no design skills. Create the complete set of necessary overlays to wow your viewers:' +
      ' thumbnails, intros, technical screens, countdowns, lower thirds, and any other overlays. Uncover' +
      ' the power of beautiful visuals that make people addicted to your content.'
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming starting soon screen templates',
      search: { name: 'LiveStartingSoon', tags: 'LiveStartingSoon' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_starting_soon;
